import { User } from '@ekkogmbh/apisdk';
import CoordinateListItem from 'src/Common/Components/CoordinateListItem';
import PaginatedSelect from 'src/Common/Components/Forms/PaginatedSelect';
import useEkko from 'src/Common/Providers/EkkoProvider';

interface Props {
  user?: User;
  disabled?: boolean;
  onChange: (user?: User) => void;
}

export default function UserPicker({ user, disabled, onChange }: Props): React.JSX.Element {
  const { api } = useEkko();
  return (
    <PaginatedSelect
      label={'User'}
      value={user}
      disabled={disabled}
      fetchPaginatedItems={(pagination) => api.getUsers(pagination, true, true)}
      itemId={(u: User) => u.id}
      itemRender={(u: User) => <CoordinateListItem label={u.username} coordinate={u.coordinate} />}
      onChange={(u) => onChange(u as User | undefined)}
    />
  );
}
